import { useMutation } from "@tanstack/react-query";
import { AuthenticationService } from "@/generated/services/AuthenticationService";
import { oauth_credentials } from "@/generated/models/oauth_credentials";

export function useAuthenticateMember() {
  return useMutation({
    mutationFn: async (payload: {
      holder_ref?: string;
      app_id?: string;
      inquiry_number_hash?: string;
      register_user?: boolean;
    }): Promise<oauth_credentials> => {
      const {
        holder_ref,
        app_id,
        inquiry_number_hash,
        register_user = false,
      } = payload;
      const response =
        await AuthenticationService.postMembersCryptedAuthentication({
          app_id,
          register_user,
          holder_ref,
          inquiry_number_hash,
          retailer_id: Number(process.env.NEXT_PUBLIC_RETAILER_ID) || 0,
        });
      return response as oauth_credentials;
    },
  });
}
